module.exports = __webpack_public_path__ + "img/C04TechSpearman3_ua.7f6e4be4.webp";